import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  px: 2,
  py: 1.5,
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
};

export const fileIcon: SxStyle = {
  color: (p) => p.palette.primary[300],
};

export const fileName: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
};

export const icon: SxStyle = {
  color: (p) => p.palette.primary[500],
};

export const button: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  color: (p) => p.palette.common.black,
  borderColor: (p) => p.palette.primary[500],
  display: 'flex',
  gap: 1,
};
